import { useCallback } from "react";
import { useRecoilValue } from "recoil";

import { RydeUiUnit, TPermissionAction } from "../models";
import { profilePermissionsSelector } from "../recoil";

interface IActionsCheck {
  entity?: RydeUiUnit;
  action?: TPermissionAction;
}

export const useHasPermissionsCheck = (): {
  hasPermissionsCheck: (actionsCheck: IActionsCheck) => boolean;
} => {
  const roleDataItem = useRecoilValue(profilePermissionsSelector);

  const hasPermissionsCheck = useCallback(
    ({ entity, action }: IActionsCheck) => {
      if (!entity || !roleDataItem?.permissions?.[entity]) {
        return false;
      }

      return (
        roleDataItem?.permissions?.[entity]?.some(act => act === action) ??
        false
      );
    },
    [roleDataItem?.permissions],
  );

  return { hasPermissionsCheck };
};
